import { Box } from '@mui/material';
import { useState } from 'react';
import Header from '../../components/dashboard/Header';
import HostDashboardContent from '../../components/dashboard/HostDashboardContent';
import HostSideDrawer from '../../components/dashboard/HostSideDrawer';

const HostDashboardPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => setSidebarOpen((open) => !open);

  return (
    <Box sx={{ display: 'flex' }}>
      <Header onToggleSidebar={toggleSidebar} open={sidebarOpen} />
      <HostSideDrawer open={sidebarOpen} />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <HostDashboardContent />
      </Box>
    </Box>
  );
};

export default HostDashboardPage;
